import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import {
  downloadQuestionsAnswerHeader,
  downloadQuestionsAnswerHeaderExcel,
} from "../components/HeaderAttribute";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import * as XLSX from "sheetjs-style";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import DownloadSubmissionPopup from "../popup-containers/DownloadSubmissionPopup";
import toast from "react-hot-toast";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const DownloadQuestionsandAnswers = () => {
  // use state for auto dropdown

  const createdBy = sessionStorage.getItem("partnerId");

  const [downloadSubmissionGridData, setDownloadSubmissionGridData] = useState(
    []
  );
  const [downloadSubmissionGridDataChild, setDownloadSubmissionGridDataChild] =
    useState([]);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [checkBoxStatus, setCheckBoxStatus] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [downloadSubmission, setDownloadSubmission] = useState("");

  // use effect for auto dropdown data
  useEffect(() => {
    gridData();
  }, []);

  // gridData function for grid data
  const gridData = async () => {
    try {
      const data = {
        partner: createdBy,
      };
      const response = await BindPostAPI(
        data,
        "DownloadSubmissionAPI/BindDownloadSubmission"
      );
      if (response.data.Table.length != 0) {
        setDownloadSubmissionGridData(response.data.Table);
        setDownloadSubmissionGridDataChild(response.data.Table1);
      } else {
        setDownloadSubmissionGridData([]);
        setDownloadSubmissionGridDataChild([]);
      }
    } catch (error) {
      console.error("Error fetching download submission grid data:", error);
    }
  };

  const handle1 = (value) => {
    setSelectedRows(value);
    setCheckBoxStatus(value);
  };

  // Popup functionality
  const handlePopup = (rowIndex, flag) => {
    const selectedRow = downloadSubmissionGridData[rowIndex];
    const TxnAnswerQuestionsId = selectedRow.TxnAnswerQuestionsId;
    const filteredData = downloadSubmissionGridDataChild.filter(
      (item) => item.TxnAnswerQuestionsId === TxnAnswerQuestionsId
    );
    setDownloadSubmission(filteredData);
    console.log("filteredData12", filteredData);
    setpopUpOpen(true);
  };

  const handleExport = () => {
    
    if (checkBoxStatus.length == 0) {
      toast.error("Select Check Box", {
        duration: 3000,
        position: "top-center",
      });
      setTimeout(5000);
    } else {
      const uniqueByTxnAnswerQuestionsId = Object.values(
        downloadSubmissionGridDataChild.reduce((acc, curr) => {
          acc[curr.TxnAnswerQuestionsId] = curr; // Overwrite with the latest entry for each ID
          return acc;
        }, {})
      );
      const filteredData = uniqueByTxnAnswerQuestionsId.filter((_, index) =>
        checkBoxStatus.includes(index)
      );
      const filteredTxnAnswerQuestionsIds = filteredData.map(
        (item) => item.TxnAnswerQuestionsId
      );
      const filteredGridData = downloadSubmissionGridDataChild.filter((item) =>
        filteredTxnAnswerQuestionsIds.includes(item.TxnAnswerQuestionsId)
      );

      exportData(
        downloadQuestionsAnswerHeaderExcel
          .slice(0, -1) // Remove last header
          .map((column) => column.title),
        filteredGridData
      );
    }
  };

  const exportData = (columns, rows) => {
    
    const titleRow = [
      {
        v: "Download Submission",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "000000" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "left" },
        },
      })),
    ];
    // Initialize column totals

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ModuleName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TopicNo,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TopicName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.QuestionNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Question,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Attachment,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.IndicatedPages,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Comments,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
      ];
    });

    const wsData = [titleRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 30 }, // Branch
      { width: 15 }, // IPC  No
      { width: 30 }, // IPC  No
      { width: 15 }, // IPC  No
      { width: 100 }, // Gender
      { width: 30 }, // IPC  No
      { width: 15 }, // IPC  No
      { width: 100 }, // IPC  No
    ];

    ws["!rows"] = [
      { hpt: 30 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    // Create and save workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Download Submission.xlsx");
  };

  const handleDownload = async () => {
    if (checkBoxStatus.length === 0) {
      toast.error("Select Check Box", {
        duration: 3000,
        position: "top-center",
      });
    } else {
      const filteredData = downloadSubmissionGridData.filter((_, index) =>
        checkBoxStatus.includes(index)
      );
      const filteredTxnAnswerQuestionsIds = filteredData.map(
        (item) => item.TxnAnswerQuestionsId
      );
      const filteredGridData = downloadSubmissionGridDataChild.filter((item) =>
        filteredTxnAnswerQuestionsIds.includes(item.TxnAnswerQuestionsId)
      );

      // Group by QuestionNumber
      const groupedByQuestion = filteredGridData.reduce((acc, item) => {
        const key = item.QuestionNumber;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      for (const [questionNumber, items] of Object.entries(groupedByQuestion)) {
        const zip = new JSZip();

        for (const item of items) {
          if (item.AttachedDocument) {
            const fileName = item.AttachedDocument.split("/").pop();

            try {
              const response = await fetch(item.AttachedDocument);
              const blob = await response.blob();
              zip.file(fileName, blob);
            } catch (err) {
              console.error(`Failed to fetch: ${item.AttachedDocument}`, err);
            }
          }
        }

        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `Question_${questionNumber}.zip`);
      }
    }
  };

  return (
    <MainLayout pageName={"4"}>
      <div>
        <ReportGridPage
          title="Download Submission"
          header={downloadQuestionsAnswerHeader}
          records={downloadSubmissionGridData}
          handleExport={handleExport}
          handleDownload={handleDownload}
          checkBoxStatus={handle1}
          handleAction={handlePopup}
          selectedRows={selectedRows ?? []}
        />
      </div>

      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Download Submission"
            setpopUpOpen={setpopUpOpen}
            hederDetails={[]}
          />

          <DownloadSubmissionPopup data={downloadSubmission} />
        </div>
      </MainPopup>
    </MainLayout>
  );
};

export default DownloadQuestionsandAnswers;
